import React, { useEffect, useState } from 'react'
import Img1 from '../assets/images/awards/Img1.webp'
import Img2 from '../assets/images/awards/Img2.png'
import Img3 from '../assets/images/awards/Img3.png'
import Img4 from '../assets/images/awards/Img4.png'
import Img5 from '../assets/images/awards/Img5.png'

const AwardsAndAchievementsSection = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const awards = [
        {
            id: 1,
            title: 'Binghatti Award',
            category: 'Sales Excellence',
            year: '2025',
            image: Img1,
        },
        {
            id: 2,
            title: 'Shahrukhz by Danube Competition',
            category: 'Sales Excellence',
            year: '2025',
            image: Img2,
        },
        {
            id: 3,
            title: '1% Elite Broker Award by Danube',
            category: 'Elite Recognition',
            year: '2025',
            image: Img3,
        },
        {
            id: 4,
            title: 'Gulf Achievers Award 2025',
            category: 'Regional Excellence',
            year: '2025',
            image: Img4,
        },

        {
            id: 5,
            title: 'The Asian Arab Business Awards 2025',
            category: 'Excellence & Innovation',
            year: '2025',
            image: Img5,
        },
    ]

    const [currentSlide, setCurrentSlide] = useState(0)
    const [awardsPerSlide, setAwardsPerSlide] = useState(3)
    const [autoPlay, setAutoPlay] = useState(true)
    const totalSlides = awards.length - awardsPerSlide + 1

    useEffect(() => {
        const handleResize = () => {
            setAwardsPerSlide(window.innerWidth >= 768 ? 3 : 1)
        }

        handleResize()
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    useEffect(() => {
        setCurrentSlide(0)
    }, [awardsPerSlide])

    // Auto-play effect
    useEffect(() => {
        if (!autoPlay) return

        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % totalSlides)
        }, 3000) // Auto-advance every 5 seconds

        return () => clearInterval(interval)
    }, [autoPlay, totalSlides])

    const goToSlide = (index) => {
        setCurrentSlide(index)
        setAutoPlay(false)
        setTimeout(() => setAutoPlay(true), 7000)
    }

    return (
        <>
            {/* Awards Carousel */}
            <section className="container-fluid">
                <div className="text-center">
                    <div className="text-ss-primary fs-ss-18 fw-400">Recent Recognition</div>
                    <h2 className="pb-md-4 pb-3 text-white fs-ss-35 fw-500 lh-sm">Prestigious Awards</h2>
                </div>

                <div
                    className="position-relative px-4 col-md-10 mx-auto px-md-5"
                    onMouseEnter={() => setAutoPlay(false)}
                    onMouseLeave={() => setAutoPlay(true)}
                >
                    <div className="overflow-hidden">
                        <div
                            className="d-flex transition-transform"
                            style={{
                                transform: `translateX(-${currentSlide * (100 / awardsPerSlide)}%)`,
                                transition: 'transform 0.5s ease-in-out',
                                gap: awardsPerSlide === 3 ? '1.5rem' : '0',
                                paddingRight: awardsPerSlide === 3 ? '1.5rem' : '0',
                            }}
                        >
                            {awards.map((award, index) => (
                                <div
                                    key={award.id}
                                    className="flex-shrink-0"
                                    style={{ width: awardsPerSlide === 3 ? 'calc(33.33% - 1rem)' : '100%' }}
                                >
                                    <div className="border-white border-1 border h-100 d-flex flex-column">
                                        <div className="text-center">
                                            <div className="pb-3">
                                                <img
                                                    src={award.image}
                                                    alt={award.title}
                                                    className="w-100"
                                                    onError={(e) => {
                                                        e.target.src =
                                                            'https://via.placeholder.com/300x200/1a1a1a/ffffff?text=Award+Image'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="p-4 flex-grow-1 d-flex flex-column">
                                            <h3 className="text-white fs-ss-22 fw-500 text-center mb-3">
                                                {award.title}
                                            </h3>
                                            <div className="mt-auto">
                                                {award.category && award.year && (
                                                    <div className="text-center">
                                                        <span className="badge bg-ss-primary text-white fs-ss-14 fw-400">
                                                            {award.category}
                                                        </span>
                                                        <span className="ms-2 badge bg-secondary text-white fs-ss-14 fw-400">
                                                            {award.year}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Dots Indicator */}
                    {totalSlides > 1 && (
                        <div className="text-center mt-4">
                            {Array.from({ length: totalSlides }).map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => goToSlide(index)}
                                    className={`mx-1 border-0 ${
                                        currentSlide === index ? 'bg-ss-primary' : 'bg-secondary'
                                    }`}
                                    style={{
                                        width: '8px',
                                        height: '8px',
                                        borderRadius: '50%',
                                        padding: 0,
                                        cursor: 'pointer',
                                    }}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </section>
        </>
    )
}

export default AwardsAndAchievementsSection
